var _g;
var _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var SvgRakValueMax = function SvgRakValueMax(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#3B3A3A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M67.997 19h2.053c5.136 0 8.95 4.11 8.95 9.18v39.642C79 72.89 74.837 77 69.701 77H10.298C5.163 77 1 72.89 1 67.822V28.178C1 23.11 5.037 19 10.172 19h1.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8E1538",
    d: "M21.194 43.02l9.176 17.443a1 1 0 0 0 1.603.23l9.824-10.14 9.823 10.14a1 1 0 0 0 1.559-.153L68.99 36.057a1 1 0 0 0-1.68-1.086l-15.13 23.427-9.666-9.978a1 1 0 0 0-1.436 0l-9.581 9.89-9.376-17.82a1 1 0 0 0-1.75-.038L9.307 59.495a1 1 0 0 0 1.73 1.005l10.157-17.48zM60 0a4 4 0 0 1 4 4v20a4 4 0 0 1-4 4H44.863l-4.079 6.293a.5.5 0 0 1-.84 0L35.866 28H21a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4h39z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M28.827 19l-3.238-9.15h-.062a60.31 60.31 0 0 1 .13 3.822V19H24V8.045h2.574l3.1 8.715h.046l3.193-8.715h2.58V19h-1.756v-5.418c0-.544.014-1.253.042-2.128.028-.874.053-1.403.073-1.588h-.061L30.438 19h-1.611zm16.534 0l-1.115-3.042h-4.27L38.886 19H36.96l4.178-11h1.985l4.178 11h-1.94zm-1.596-4.586l-1.046-2.982a18.17 18.17 0 0 1-.317-.944 20.12 20.12 0 0 1-.28-.944 16.553 16.553 0 0 1-.602 2.015l-1.009 2.855h3.254zM57 19h-2.1l-2.795-4.48L49.287 19H47.33l3.704-5.68-3.467-5.275H49.6l2.581 4.144 2.581-4.144h1.97l-3.49 5.305L57 19z"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRakValueMax, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/rak-value-max.c4eba149.svg";
export { ForwardRef as ReactComponent };